export const getIdCompanyByLocalStorage = () => {
    const key = localStorage.getItem('chaveUnicaCliente') ?? '';
    const chaveUnica = key ? JSON.parse(key) : '';
    return chaveUnica;
}